import React, { useState } from 'react';
import TextField from 'components/crm/ui/TextField';
import useText from 'hooks/useText';
import {
  formatPhone,
  phoneDigitCount,
  phoneErrorCode,
} from 'helper/prospectPhone';

const FULL_LENGTH = 10;

const PhoneField = ({
  id,
  label,
  value,
  onChange,
  required,
  placeholder,
  forceError,
}) => {
  const { text } = useText('prospection.addProspect.phoneErrors');
  const [left, setLeft] = useState(false);

  const code =
    !required && !String(value ?? '').trim() ? null : phoneErrorCode(value);
  const visible = left || forceError || phoneDigitCount(value) >= FULL_LENGTH;

  const handleBlur = () => {
    setLeft(true);
    if (!phoneErrorCode(value) && String(value ?? '').trim()) {
      const formatted = formatPhone(value);
      if (formatted !== value) onChange(formatted);
    }
  };

  return (
    <TextField
      id={id}
      label={label}
      type="tel"
      inputMode="tel"
      autoComplete="off"
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      onBlur={handleBlur}
      error={visible && code ? text(code) : undefined}
    />
  );
};

export default PhoneField;
